/**
 * Rol segmenti yardımcıları (bütçe bar'ı + program bitiş sayacı).
 *
 * `authUser.roleName` = `Role.description`, yani tenant'a göre değişebilen
 * serbest metindir ("İşletme", "CRG Satış Temsilcisi", "CRG Bölge Müdürü" ...).
 * Segment kontrolünü bu metne göre yapmak her yeni rolde sessizce kırılıyordu
 * (CRGAREAMANAGER strip'i göremiyordu). Bu yüzden kontrol rol KODU
 * (`EmployeeFirm.role`) üzerinden yapılır; kod yoksa (eski/eksik token) ad bazlı
 * yedek eşleşmeye düşülür.
 */

export const ROLE_DEALER = "USER"; // Bayi
export const ROLE_BUSINESS = "USER2"; // İşletme
export const ROLE_CHEF = "USER3"; // Usta

/** Bayi sorumlusu roller — connection-frontendAdmin DEALER_RESPONSIBLE_ROLES ile aynı liste. */
export const DEALER_RESPONSIBLE_ROLES = ["CRGSALESREP", "CRGAREAMANAGER"];

/** Ana sayfadaki bütçe bar'ını gören segment: Bayi + İşletme + bayi sorumlusu roller (Usta hariç). */
export const BUDGET_BAR_ROLES = [
  ROLE_DEALER,
  ROLE_BUSINESS,
  ...DEALER_RESPONSIBLE_ROLES,
];

/** Header'daki program bitiş sayacını gören segment: bütçe bar segmenti + Usta. */
export const PROGRAM_COUNTER_ROLES = [...BUDGET_BAR_ROLES, ROLE_CHEF];

/** Türkçe karakterleri sadeleştirip büyütür (ad bazlı yedek eşleşme için). */
export const normalizeRole = (s) =>
  (s || "")
    .replace(/İ/g, "I")
    .replace(/ı/g, "i")
    .replace(/Ş/g, "S")
    .replace(/ş/g, "s")
    .replace(/Ç/g, "C")
    .replace(/ç/g, "c")
    .replace(/Ğ/g, "G")
    .replace(/ğ/g, "g")
    .replace(/Ü/g, "U")
    .replace(/ü/g, "u")
    .replace(/Ö/g, "O")
    .replace(/ö/g, "o")
    .toUpperCase()
    .trim();

/**
 * Giriş yapan kullanıcının rol kodu (`authUser.employeeFirm.role`).
 * DB'de CHAR kolon olduğundan kod boşluk dolgulu gelebilir; normalize kırpar.
 */
export const getRoleCode = (authUser) =>
  normalizeRole(authUser?.employeeFirm?.role);

/** Ad bazlı yedek: rol kodu gelmediğinde segmenti rol adından tahmin eder. */
const matchesByName = (roleName, { includeChef }) => {
  const n = normalizeRole(roleName);
  if (n.includes("USTA")) {
    return includeChef;
  }
  return (
    n.includes("BAYI") ||
    n.includes("ISLETME") ||
    n.includes("TEMSILCI") ||
    n.includes("MUDUR")
  );
};

/** Ana sayfa bütçe bar'ı gösterilsin mi? */
export const isBudgetBarSegment = (authUser, roleName) => {
  const code = getRoleCode(authUser);
  return code
    ? BUDGET_BAR_ROLES.includes(code)
    : matchesByName(roleName, { includeChef: false });
};

/** Header program bitiş sayacı gösterilsin mi? */
export const isProgramCounterSegment = (authUser, roleName) => {
  const code = getRoleCode(authUser);
  return code
    ? PROGRAM_COUNTER_ROLES.includes(code)
    : matchesByName(roleName, { includeChef: true });
};
